export default {
  moleServerUrl: 'http://localhost:8080'
};



/** WEBPACK FOOTER **
 ** ./src/config.js
 **/